import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { useTranslation } from 'react-i18next'
import LoadingButton from '../../Button/LoadingButton'

function LogoutModal({ isOpen, closeLogoutDialog, handleLogout }) {
	const { t } = useTranslation()
	const { t: tSettings } = useTranslation('settings')
	const { t: tClientDeleteDialog } = useTranslation('ClientDeleteDialog')

	const logout = () => {
		handleLogout()
		closeLogoutDialog()
	}
	const cancelLogout = () => {
		closeLogoutDialog()
	}

	return (
		<Dialog open={isOpen} aria-labelledby="logout-confirmation-dialog">
			<DialogContent>
				<DialogContentText>
					{tSettings('logoutConfirmation')}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<LoadingButton
					onClick={logout}
					color="secondary"
					variant="contained"
				>
					{tSettings('logout')}
				</LoadingButton>
				<Button
					onClick={cancelLogout}
					color="primary"
					variant="contained"
				>
					{tClientDeleteDialog('cancel')}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default LogoutModal
